import type { TableUISettings } from "@lib/hooks/useTableUISettings";
import { createColumns } from "@/lib/table/columnFactory";
import type { Ticket } from "../types/ticket.types";
import { actionsColumnFactory } from "./actions";
import { categoryColumnFactory } from "./category";
import { createdAtColumnFactory } from "./createdAt";
import { referenceColumn } from "./reference";
import { selectColumn } from "./select";
import { statusColumnFactory } from "./status";
import { titleColumnFactory } from "./title";
import { resolveTicketColumnSettings } from "./types";

export type { Ticket } from "../types/ticket.types";

export function getTicketColumns(uiSettings?: TableUISettings) {
  const settings = resolveTicketColumnSettings(uiSettings);

  return createColumns<Ticket>([
    selectColumn,
    referenceColumn,
    titleColumnFactory(settings),
    statusColumnFactory(settings),
    categoryColumnFactory(settings),
    createdAtColumnFactory(settings),
    actionsColumnFactory(settings),
  ]);
}
